"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockFlavorPickerItems = void 0;
var mockFlavorPickerItems = [{
  itemType: 'CNR',
  itemId: 204200,
  typeDescription: '2L Pepsi Products',
  itemSubtext: 'Choose your 2-Liter',
  patternStripping: ' 2 Liter'
}, {
  itemType: 'CNR',
  itemId: 204100,
  typeDescription: '20 oz. Pepsi Products',
  itemSubtext: 'Choose your 20 oz.',
  patternStripping: ' 20 oz'
}, {
  itemType: 'HNRS',
  itemId: 105001,
  typeDescription: 'Caesar Wings®',
  itemSubtext: 'Choose your sauce',
  patternStripping: 'Caesar Wings® - '
}, {
  itemType: 'DDD',
  itemId: 601001,
  typeDescription: '$5.99 Lunch Combo',
  itemSubtext: 'Choose your 20 oz.',
  patternStripping: '$5.99 Lunch Combo '
}];
exports.mockFlavorPickerItems = mockFlavorPickerItems;